<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="contractorListHeaders"
    :request-func="getContractorList"
    @click:row="
      $router.push({
        name: 'single-contractor',
        params: { id: $event.id },
      })
    ">
    <template #action-button>
      <v-btn v-if="can('contractors.create')" @click="createContractor">
        <v-icon>mdi-plus</v-icon>
        Створити контрагента
      </v-btn>
    </template>
    <template #item.name="{ item }">
      <div class="d-flex flex-column">
        <span v-if="item.shortName">{{ item.shortName }}</span>
        <span v-if="item.name">{{ item.name }}</span>
      </div>
    </template>
    <template #item.type="{ item }">
      <v-chip
        :color="item.typeId === 1 ? 'blue-darken-3' : 'deep-purple'"
        class="font-weight-bold"
        size="small"
        variant="tonal">
        {{ item.type.name }}
      </v-chip>
    </template>
  </b-server-table>
</template>

<script lang="ts">
import { ref } from 'vue'
import { openDialog } from '@/dialog/index.ts'
import { BServerTable } from 'best-modules/components/index'
import { contractorListHeaders } from '@/utils/tableHeaders'
import { useCan } from '@/composables/useCan'
import { useRouter } from 'vue-router'
import { contractorList as contractorListRequest } from '@/requests/contractor'

export default {
  components: { BServerTable },
  data: () => {
    return {
      contractorListHeaders,
    }
  },
  setup() {
    const router = useRouter()
    const { can } = useCan()
    const tableRenderKey = ref<number>(1)

    const getContractorList = (query: any) => {
      return contractorListRequest({ ...query, paginate: true })
    }

    const createContractor = () => {
      openDialog({
        name: 'Contractor',
        params: {
          cb: contractor => {
            router.push({
              name: 'single-contractor',
              params: { id: contractor.id },
            })
          },
        },
      })
    }

    return {
      getContractorList,
      tableRenderKey,
      createContractor,
      can,
    }
  },
}
</script>

<style lang="scss" scoped></style>
